module.exports = __webpack_public_path__ + "static/media/404.a9f4b3f6.png";